import { getISOWeek, getISOWeekYear } from "date-fns";

import { sessionPrefix } from "./helpers";

export const weekCalendarPath = (session: LightSessionInterface, date: Nullable<Date> = null) => {
  if (!date) {
    date = new Date();
  }

  const wno = getISOWeek(date);
  const year = getISOWeekYear(date);

  return `${sessionPrefix(session)}/calendar/c/${year}/w${wno}`;
};

export const monthCalendarPath = (session: LightSessionInterface, date: Nullable<Date> = null) => {
  if (!date) {
    date = new Date();
  }

  return `${sessionPrefix(session)}/calendar/c/${date.getFullYear()}/${date.getMonth() + 1}`;
};

export const dayCalendarPath = (session: LightSessionInterface, date: Nullable<Date> = null) => {
  if (!date) {
    date = new Date();
  }

  return `${sessionPrefix(session)}/calendar/c/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
};

export const agendaCalendarPath = (session: LightSessionInterface, date: Nullable<Date> = null) => {
  if (!date) {
    date = new Date();
  }

  return `${sessionPrefix(session)}/calendar/c/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}/agenda`;
};

export const calendarPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/calendar`;
export const calendarSendEventsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/calendar/send`;

export const calendarFeedbackPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/calendar/feedback`;
export const showCalendarFeedbackPath = (session: LightSessionInterface, feedback: EventFeedbackRef) =>
  `${sessionPrefix(session)}/calendar/feedback/${feedback.id}`;
export const editCalendarFeedbackPath = (session: LightSessionInterface, feedback: EventFeedbackRef) =>
  `${sessionPrefix(session)}/calendar/feedback/${feedback.id}/edit`;
export const newCalendarFeedbackPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/calendar/feedback/new`;

export const calendarEventsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/calendar/events`;
export const transferCalendarEventsPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/calendar/events/transfer`;
export const showCalendarEventPath = (session: LightSessionInterface, event: EventRef) =>
  `${sessionPrefix(session)}/calendar/events/${event.id}`;

export const calendarStornosPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/calendar/stornos`;
export const showCalendarStornoPath = (session: LightSessionInterface, storno: EventFeedbackRef) =>
  `${sessionPrefix(session)}/calendar/stornos/${storno.id}`;
